import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calculate-result',
  templateUrl: './calculate-result.component.html',
  styleUrls: ['./calculate-result.component.scss']
})
export class CalculateResultComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
